import React, { PureComponent } from 'react'
import Module from '~/components/Module'
import talkIcon from '~/assets/icon-suggest.svg'
import SVG from '~/components/SVG'
import { universalOpenUrl } from '~/utils'
import styles from './styles.css'

export default class Experience extends PureComponent {
  handleClick = () => universalOpenUrl(this.props.url)
  render() {
    const imgSize = {
      width: document.body.clientWidth - 45,
      height: (document.body.clientWidth - 45) / 330 * 170,
    }
    return (
      <Module
        headerIcon={
          <SVG src={talkIcon} width={14} height={14} fill="#0084ff" />
        }
        headerText="超级会员卡免费领"
      >
        <div className={styles.card} onClick={this.handleClick}>
          <img src={this.props.img} alt="" style={imgSize} />
        </div>
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Experience/index.js